// import React from 'react';
// import './GoalReportPage.css';
// export const getChangeIndicator = (value) => {
//   if (!value) return null;

//   const isPositive = value.startsWith('+');
//   const cleanValue = value.replace('+', '').replace('-', '').trim();
//   const color = isPositive ? '#22C55E' : '#F46464'; // Green for positive, Red for negative
//   const directionText = isPositive ? 'more' : 'less';

//   const ArrowIcon = isPositive ? (
//     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
//       <path d="M17 1L10.2 7.8L6.19999 3.8L1 9" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
//       <path d="M12.2 1H17V5.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   ) : (
//     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none" style={{ transform: 'rotate(180deg)' }}>
//       <path d="M17 1L10.2 7.8L6.19999 3.8L1 9" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
//       <path d="M12.2 1H17V5.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );

//   return (
//     <span style={{ color, display: 'inline-flex', alignItems: 'center', gap: '4px' }} >
//       {ArrowIcon}
//       {cleanValue} {directionText} than last month
//     </span>
//   );
// };


import React from 'react';
import './GoalReportPage.css';

export const getChangeIndicator = (value) => {
  if (!value) return null;

  const isPositive = value.startsWith('+');
  const cleanValue = value.replace('+', '').replace('-', '').trim();
  
  // Treat as negative if no + or - present
  const isActuallyPositive = isPositive;
  const isActuallyNegative = !value.startsWith('+') && !value.startsWith('-') ? true : !isPositive;

  const color = isActuallyPositive ? '#22C55E' : '#F46464'; // Green for positive, Red for negative
  const directionText = isActuallyPositive ? 'more' : 'less';

  const ArrowIcon = isActuallyPositive ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
      <path d="M17 1L10.2 7.8L6.19999 3.8L1 9" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.2 1H17V5.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none" style={{ transform: 'rotate(180deg)' }}>
      <path d="M17 1L10.2 7.8L6.19999 3.8L1 9" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.2 1H17V5.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  return (
    <span style={{ color, display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      {ArrowIcon}
      {cleanValue} {directionText} than last month
    </span>
  );
};
